"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _PanelGroup = _interopRequireDefault(require("./components/PanelGroup"));
var dashboard = _interopRequireWildcard(require("@/api/dashboard"));
var _date = require("@/utils/date");
var _Customer = _interopRequireDefault(require("./components/chart/Customer.vue"));
var _OrderChart = _interopRequireDefault(require("./components/chart/OrderChart.vue"));
var _Top10Staff = _interopRequireDefault(require("./components/chart/Top10Staff.vue"));
var _Top10Product = _interopRequireDefault(require("./components/chart/Top10Product.vue"));
var _OrderTable = _interopRequireDefault(require("@/views/order/OrderTable.vue"));
var _order = require("@/api/order");
var _moment = _interopRequireDefault(require("moment"));
var _OrderModal = _interopRequireDefault(require("@/views/order/components/OrderModal.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "DashboardAdmin",
  components: {
    PanelGroup: _PanelGroup.default,
    CustomerChart: _Customer.default,
    OrderChart: _OrderChart.default,
    Top10Staff: _Top10Staff.default,
    Top10Product: _Top10Product.default,
    OrderTable: _OrderTable.default,
    OrderModal: _OrderModal.default
  },
  data: function data() {
    return {
      loading: false,
      query: {
        page: 1,
        limit: 10
      },
      total: 0,
      orders: []
    };
  },
  computed: {
    transformOrders: function transformOrders() {
      var data = [];
      data = this.orders.map(function (order) {
        var total = 0;
        order.orderDetails.forEach(function (orderDetal) {
          total += orderDetal.originPrice * orderDetal.quantity;
        });
        order.totalOriginPrice = total;
        order.dateLeft = order.remindDate - (0, _moment.default)().unix();
        return order;
      });
      return data;
    }
  },
  created: function created() {
    this.fetchOrders();
  },
  methods: {
    handleUpdate: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    },
    fetchOrders: function fetchOrders() {
      var _this = this;
      this.loading = true;
      _order.orderApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), {}, {
        sortByRemind: true
      })).then(function (res) {
        _this.orders = res.data.orders;
        _this.total = res.data.total;
      }).finally(function () {
        return _this.loading = false;
      });
    },
    handleRemind: function handleRemind(row) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$confirm("Confirm change", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Yes",
                type: "warning"
              });
            case 2:
              _order.orderApi.update(row.id, {
                order: {
                  isHandled: true
                }
              }).then(function (res) {
                _this2.fetchOrders();
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};